import Table from '@components/common/Table';
import { Card } from 'antd';
import React from 'react';


const mockKeys = ['Metis', 'Adrastea', 'Thebe', 'Europa', 'Callisto', 'Helike'];

const columns = mockKeys.map(key => ({
  title: key,
  dataKey: key.toLowerCase(),
  key: key.toLowerCase(),
  flexGrow: 1,
  align: 'right',
  width: 100,
  minWidth: 80,
}));

const data:any = [];

for(let i=0; i<10;i++) {
  const row = {};
  columns.forEach( ({ key }, idx) => {
    row[key] = idx % 2 === 0 ? btoa(`${Math.random()}`).substring(5,10) : Math.floor(Math.random() * 1000);
  });
  data.push(row);
}

function Tables() {
  return (
    <Card title="Table (react-base-table)">
        <Table
          style={{ minHeight: 250 }}
          data={data}
          columns={columns}
        />
    </Card>
  )
}


export default Tables;
